import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCGIxA1xo0x2fKta1eoShOGIWHGBMZGY64',
    libraries: 'places' // This is required if you use the Autocomplete plugin
  }
})
